import { ActionIcon, Flex, type ActionIconProps, type FlexProps } from "@mantine/core";
import React from "react";

import styles from "./YachtSetUp.module.scss";

export const StyledYachtSetUpItem: React.FC<FlexProps> = ({
  className,
  ...props
}) => (
  <Flex className={`${styles.styledYachtSetUpItem} ${className ?? ""}`} {...props} />
);

export const StyledRemoveActionIcon: React.FC<ActionIconProps> = ({
  className,
  ...props
}) => (
  <ActionIcon
    className={`${styles.styledRemoveActionIcon} ${className ?? ""}`}
    {...props}
  />
);
